<ng-container *ngIf="filteredPatients.length; else noItems">
    <mat-list>
        <ng-container *ngFor="let group of filteredPatients">
            <ng-container *ngIf="group.items.length">
                <div class="list-header">{{group.date | date: 'longDate'}}</div>
                <mat-list-item *ngFor="let morbidityMortality of group.items"
                    (click)="navigateToPatientFile(morbidityMortality.Patient.id)" class="auto-height"
                    [appPatientActive]="morbidityMortality.Patient.id" [appPatientValidationStatus]="morbidityMortality.Patient"
                    #valStatus="appPatientValidationStatus">
                    <div class="patient-item">
                        <div class="patient-details">
                            <app-patient-validation-messages [valStatus]="valStatus"></app-patient-validation-messages>
                            <div matLine class="patient-name">
                                <b>{{ morbidityMortality.Patient.surname }}, {{ morbidityMortality.Patient.name }}</b>
                                <span class="patient-number" *ngIf="morbidityMortality.Patient.patientNumber">({{
                                    morbidityMortality.Patient.patientNumber
                                    }})</span>
                            </div>
                            <div matLine class="patient-diagnosis">
                                <span>{{ morbidityMortality.Patient.diagnosis }}</span>
                            </div>
                            <div matLine *ngIf="morbidityMortality.Patient.diagnosis2" class="patient-secondary-diagnosis">
                                <span>{{ buildDiagnosisString(morbidityMortality.Patient) }}</span>
                            </div>
                            <div matLine class="morbidity-mortality-type" [ngClass]="{'mortality': morbidityMortality.isMortality, 'morbidity': morbidityMortality.isMorbidity}">
                                <mat-icon class="type-icon">{{ getMorbidityMortalityIcon(morbidityMortality) }}</mat-icon>
                                <span class="type-label">{{ getMorbidityMortalityType(morbidityMortality) }}</span>
                            </div>
                            <div matLine class="note-title" *ngIf="morbidityMortality.title">
                                <strong>Title:</strong> {{ morbidityMortality.title }}
                            </div>
                            <div matLine class="note-content" *ngIf="morbidityMortality.notes">
                                <strong>Notes:</strong> {{ morbidityMortality.notes }}
                            </div>
                        </div>
                        <div class="view-icon">
                            <mat-icon>visibility</mat-icon>
                        </div>
                    </div>
                </mat-list-item>
            </ng-container>
        </ng-container>
        <div class="mobile-spacer"></div>

    </mat-list>
</ng-container>

<ng-template #noItems>
    <p class="no-records-message">No morbidity & mortality cases found.</p>
</ng-template>

